export const LOGOUT_STORAGE_KEY = "orbitshift:logout"

export function notifyLogout() {
  if (typeof window === "undefined") return

  try {
    window.localStorage.setItem(LOGOUT_STORAGE_KEY, String(Date.now()))
  } catch {
    // Storage can be unavailable in private browsing or restricted contexts.
  }
}

export function subscribeToLogout(onLogout: () => void) {
  if (typeof window === "undefined") return () => {}

  const handleStorage = (event: StorageEvent) => {
    if (event.key === LOGOUT_STORAGE_KEY && event.newValue) onLogout()
  }

  window.addEventListener("storage", handleStorage)
  return () => window.removeEventListener("storage", handleStorage)
}
